import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// We no longer need the logout actions here, because the modal handles them now!

const STORAGE_KEY = 'IWK_AUTO_LOGOUT';
const SAVE_INTERVAL_MS = 1000;
const EVENTS_TO_MONITOR = ['click', 'keypress', 'load', 'mousedown', 'mousemove', 'scroll'];

const useAutoLogout = (loggedIn, token, history, timeoutMinutes) => {
  const dispatch = useDispatch();

  const isWarningModalOpen = useSelector(state => state.ui?.logoutWarningModalShown);

  const getLastUpdate = () => parseInt(localStorage.getItem(STORAGE_KEY)) || 0;

  const setLastUpdate = useCallback(() => {
    const timestamp = Date.now();
    const lastUpdate = getLastUpdate();
    if (timestamp - lastUpdate > SAVE_INTERVAL_MS) {
      localStorage.setItem(STORAGE_KEY, timestamp);
    }
  }, []);

  const showWarningModal = useCallback(() => {
    dispatch({ type: 'SHOW_LOGOUT_WARNING_MODAL' });
  }, [dispatch]);

  useEffect(() => {
    if (loggedIn) {
      if (!localStorage.getItem(STORAGE_KEY)) {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      }
      EVENTS_TO_MONITOR.forEach(event => window.addEventListener(event, setLastUpdate));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    return () => {
      EVENTS_TO_MONITOR.forEach(event => window.removeEventListener(event, setLastUpdate));
    };
  }, [loggedIn, setLastUpdate]);

  useEffect(() => {
    const parsedTimeout = parseInt(timeoutMinutes, 10);

    if (loggedIn && parsedTimeout > 0) {
      const interval = setInterval(() => {
        const lastUpdate = getLastUpdate();
        const timeoutMS = parsedTimeout * 60000;
        
        if (lastUpdate !== 0 && Date.now() - lastUpdate > timeoutMS) {
          if (!isWarningModalOpen) {
            showWarningModal();
          }
        }
      }, SAVE_INTERVAL_MS);
      return () => clearInterval(interval);
    }
  }, [loggedIn, timeoutMinutes, isWarningModalOpen, showWarningModal]);
};

export default useAutoLogout;
